import React, { useState } from "react";
import styled, { keyframes, css } from "styled-components";
import KakaoAdfit1 from "../KakaoAdfit/KakaoAdfit1";
import KakaoAdfit2 from "../KakaoAdfit/KakaoAdfit2";
import KakaoAdfit3 from "../KakaoAdfit/KakaoAdfit3";
import KakaoAdfit4 from "../KakaoAdfit/KakaoAdfit4";
import { isMobile } from "../common/style";
import ButtonImg from "../common/image/gacha/버튼.png";
import CoverImg from "../common/image/gacha/뚜껑.png";
import CircleImg from "../common/image/gacha/볼.png";
import SupportImg from "../common/image/gacha/아래.png";
import EntranceImg from "../common/image/gacha/입구.png";
import CapsulesImg from "../common/image/gacha/캡슐들.png";
import CapsuleImg from "../common/image/gacha/캡슐.png";
import CapsulePage from "./CapsulePage";
import koreandata from "../common/API/KoreanAPI.json";
import westerndata from "../common/API/WesternAPI.json";
import chinesedata from "../common/API/ChineseAPI.json";
import japanesedata from "../common/API/JapaneseAPI.json";
import dessertdata from "../common/API/DessertAPI.json";

const StartPage: React.FC = () => {
  const [start, setStart] = useState(false);
  const [capsules, setCapsules] = useState(false);
  const [capsule, setCapsule] = useState(false);
  const [big, setBig] = useState(false);
  const [num, setNum] = useState(0);
  const category = ["전체", "한식", "양식", "중식", "일식", "간식", "식사"];
  const [data, setData] = useState<string[]>([]);
  const [length, setLength] = useState(0);

  const GachaHandler = () => {
    setStart(true);
    let selectedData: string[] = [];

    if (category[num] === "전체") {
      selectedData = koreandata.concat(
        westerndata,
        chinesedata,
        japanesedata,
        dessertdata
      );
    } else if (category[num] === "한식") {
      selectedData = koreandata;
    } else if (category[num] === "양식") {
      selectedData = westerndata;
    } else if (category[num] === "중식") {
      selectedData = chinesedata;
    } else if (category[num] === "일식") {
      selectedData = japanesedata;
    } else if (category[num] === "간식") {
      selectedData = dessertdata;
    } else if (category[num] === "식사") {
      selectedData = koreandata.concat(westerndata, chinesedata, japanesedata);
    }

    const shuffledArray = selectedData.sort(() => Math.random() - 0.5);

    for (let i = 0; i < shuffledArray.length; i++) {
      data.push(shuffledArray[i]);
    }

    setData(data);
    setLength(data.length);
  };

  const prevClick = () => {
    if (num === 0) {
      setNum(6);
    } else {
      setNum(num - 1);
    }
  };

  const nextClick = () => {
    if (num === 6) {
      setNum(0);
    } else {
      setNum(num + 1);
    }
  };

  const clickAnimationEnd = () => {
    setTimeout(() => {
      setCapsules(true);
    }, 1000);
  };

  const capsulesAnimationEnd = () => {
    setTimeout(() => {
      setCapsule(true);
    }, 1000);
  };

  const capsuleAnimationEnd = () => {
    setTimeout(() => {
      setBig(true);
    }, 1500);
  };

  return (
    <Center>
      <h1>오늘 뭐 먹지?</h1>
      {big ? (
        <CapsuleCom>
          <CapsulePage data={data} big={big} length={length} />
        </CapsuleCom>
      ) : (
        <Container>
          <GachaDiv startani={start ? 1 : 0} capsulesani={capsules ? 1 : 0}>
            <img
              src={EntranceImg}
              alt="입구"
              className="gachaimg"
              style={{ zIndex: 60 }}
            />
            <img
              src={SupportImg}
              alt="아래"
              className="gachaimg"
              style={{ zIndex: 70 }}
            />
            <img
              src={CircleImg}
              alt="볼"
              className="gachaimg"
              style={{ zIndex: 80 }}
            />
            <img
              src={CapsulesImg}
              alt="캡슐들"
              className="gachaimg gachacap"
              style={{ zIndex: 80 }}
              onAnimationEnd={capsulesAnimationEnd}
            />
            <GachaAni
              capsuleani={capsule ? 1 : 0}
              onAnimationEnd={capsuleAnimationEnd}
            >
              <img src={CapsuleImg} alt="캡슐" className="gacha" />
            </GachaAni>
            <img
              src={CoverImg}
              alt="뚜껑"
              className="gachaimg"
              style={{ zIndex: 90 }}
            />
            <button
              onClick={GachaHandler}
              disabled={start}
              onAnimationEnd={clickAnimationEnd}
            >
              <img
                src={ButtonImg}
                alt="버튼"
                className="gachaimgbtn"
                style={{
                  zIndex: 100,
                }}
              />
            </button>
            <Select>
              <div>
                <button onClick={prevClick} disabled={start}>
                  ◀
                </button>
                <h3>{category[num]}</h3>
                <button onClick={nextClick} disabled={start}>
                  ▶
                </button>
              </div>
            </Select>
          </GachaDiv>
        </Container>
      )}
      <KakaoAdfitDiv1>
        <KakaoAdfit1 />
      </KakaoAdfitDiv1>
      <KakaoAdfitDiv2>
        <KakaoAdfit2 />
      </KakaoAdfitDiv2>
      <KakaoAdfitDiv>
        <KakaoAdfit3 />
        <KakaoAdfit4 />
      </KakaoAdfitDiv>
    </Center>
  );
};

export default StartPage;

const clickAnimation = keyframes`
  100% {
    transform: rotate(20deg);
  }
`;

const CapsulesAnimation = keyframes`
  0%, 100% {
    transform: translateY(0%);
  }
  50% {
    transform: translateY(-1%);
  }
`;

const capsuledownAnimation = keyframes`
  from {
    transform: translateY(0%) translateX(-50%);
  }
  to {
    transform: translateY(100%) translateX(-50%);
  }
`;

const capsulerotateAnimation = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;

const Center = styled.div`
  display: flex;
  position: fixed;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  left: 0;
  right: 0;
  transition: 0.5s;

  h1 {
    font-size: 27px;
    font-weight: 700;
    line-height: 150%;
    font-family: GmarketSansBold;
    color: #d4cbad;

    margin-top: 63px;
    margin-bottom: 50px;

    ${isMobile} {
      font-size: 22px;
      margin-top: 35px;
      margin-bottom: 20px;
    }
  }
`;

const Container = styled.div`
  height: 500px;

  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${isMobile} {
    height: 420px;
  }
`;

const GachaDiv = styled.div<{ startani: number; capsulesani: number }>`
  position: relative;
  width: 300px;

  ${isMobile} {
    width: 250px;
  }

  .gachaimg {
    position: absolute;
    top: 0;
    left: 0;
    width: 300px;

    ${isMobile} {
      width: 250px;
    }
  }

  .gachacap {
    animation: ${({ capsulesani }) =>
      capsulesani
        ? css`
            ${CapsulesAnimation} 0.5s linear 2
          `
        : "none"};
  }

  .gachaimgbtn {
    position: absolute;
    width: 60px;
    top: 159%;
    left: 41%;
    animation: ${({ startani }) =>
      startani
        ? css`
            ${clickAnimation} 0.3s ease-in-out forwards
          `
        : "none"};

    ${isMobile} {
      width: 50px;
      top: 149%;
      left: 40%;
    }
  }

  button {
    cursor: pointer;

    &:disabled {
      cursor: default;
    }
  }
`;

const GachaAni = styled.div<{ capsuleani: number }>`
  position: absolute;
  top: 155%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 65;
  justify-content: center;
  animation: ${({ capsuleani }) =>
    capsuleani
      ? css`
          ${capsuledownAnimation} 1s ease-in-out forwards
        `
      : "none"};

  ${isMobile} {
    top: 152%;
  }

  .gacha {
    animation: ${({ capsuleani }) =>
      capsuleani
        ? css`
            ${capsulerotateAnimation} 2s forwards
          `
        : "none"};

    ${isMobile} {
      width: 60px;
    }
  }
`;

const Select = styled.div`
  display: flex;
  justify-content: center;

  div {
    z-index: 999999;
    margin-top: 130px;
    width: 115px;
    height: 54px;
    border: 3px solid #e72025;
    background: #fff5f5;
    border-radius: 100px;

    display: flex;
    justify-content: center;
    align-items: center;

    ${isMobile} {
      margin-top: 108px;
      width: 100px;
      height: 50px;
    }
  }

  button {
    background: transparent;
    border: none;
    margin-top: 3px;

    color: #e72025;
    font-family: GmarketSansBold;
    font-size: 18px;
    font-weight: 700;
    padding: 0;

    ${isMobile} {
      font-size: 15px;
    }
  }

  h3 {
    color: #e72025;
    font-family: GmarketSansBold;
    font-size: 22px;
    font-weight: 700;
    padding: 0 8px;
    margin-top: 3px;

    ${isMobile} {
      font-size: 18px;
    }
  }
`;

const KakaoAdfitDiv1 = styled.div`
  margin-top: 100px;
  margin-right: 920px;
  position: absolute;
`;

const KakaoAdfitDiv2 = styled.div`
  margin-top: 100px;
  margin-left: 920px;
  position: absolute;
`;

const KakaoAdfitDiv = styled.div`
  position: relative;
`;

const CapsuleCom = styled.div`
  height: 500px;
  width: 650px;

  ${isMobile} {
    height: 420px;
    width: 300px;
  }
`;
